import React from "react";

const CrudSucursalesTableRow = ({ el, setData2toEdit, deleteData }) => {
	let { id, agency } = el;
	return (
		<tr className="fila-tabla-cuenstas">
			<td className="col-tabla-cuenta">{agency}</td>
			<td className="col-tabla-cuenta">
				<button onClick={() => setData2toEdit(el)} className="btn-editar">
					Editar
				</button>
				<button onClick={() => deleteData(id)} className="btn-close-accounts">
					Eliminar
				</button>
			</td>
		</tr>
	);
};

export default CrudSucursalesTableRow;
